<script>
import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  data() {
    return {
      badges: [
        {
          name: 'shield-lock',
          text: this.t('pay.js.marketing.trust.connection')
        },
        {
          name: 'bolt',
          text: this.t('pay.js.marketing.trust.checkout')
        },
      ]
    };
  }
};
</script>

<template>
  <div class="row g-0 c-trust-badges">
    <div
      v-for="badge in badges"
      :key="badge.name"
      class="col-6 d-flex align-items-center"
    >
      <icon
        class="flex-shrink-0"
        :name="badge.name"
        size="medium"
      />

      <span class="c-trust-badge__text">
        {{ badge.text }}
      </span>
    </div>
  </div>
</template>
